import { ComponentDataSourceService } from '../../component-data-source.service';
import { DataSourceFunction } from '../../component-data-source.service';
import { EventParticipantDTO } from '../../../../dto/event/event-participant.dto';
import { createEventParticipantDataSource } from './event_participants';
import { isAfbudParticipationStatus } from '../../../../constants/event-participant-status.utils';

export const event_cancellations = (service: ComponentDataSourceService): DataSourceFunction =>
  createEventParticipantDataSource(service, {
    name: 'event_cancellations',
    description: 'Event participants with afbud/cancellation status',
    columnProfile: 'compact',
    participantFilter: (participant: EventParticipantDTO) =>
      participant.role !== 'instructor' && isAfbudParticipationStatus(participant.status),
  });
